(function ($) {
	$(document).ready(function () {
		$('.static-banner-block .video-close-container').click(function(){

			var video = document.getElementById("static-banner-video");
			if($(this).hasClass('paused')){
				video.play();
			}else{
				video.pause();
			}
			console.log('this was clicked');
			$(this).toggleClass('paused');
			$(this).find('.pause').toggleClass('active');
			$(this).find('.play').toggleClass('active');

		});

        /**
         * Functionality to stop videos when the modal is closed.
         */
        $.each($('.static-banner-block .video-modal'), function () {
            let videoContainer = $('.embed-responsive', $(this));
            let videoIframe = $(this).find('iframe');
            let videoCode = '';

            // Set the target video source element, depending on if it's a video or an iframe.
            if ($('video', $(videoContainer)).length > 0) {
                videoCode = $('video', $(videoContainer));
            } else {
                videoCode = $('iframe', $(videoContainer));
            }

            // When the modal is closed, remove the video element.
            $(this).on('hidden.bs.modal', function() {
                $(videoCode).remove();
            });

            // When the modal is opened, add it back.
            $(this).on('show.bs.modal', function() {
                $(videoContainer).append($(videoCode));
            });

            // Remove width and height attrs that come with iframe code.
            if (videoIframe.length > 0) {
                videoIframe.removeAttr('width').removeAttr('height');
            }
        });

    });
})(jQuery);
